import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-3 container" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "search-container" }
const _hoisted_5 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectSummaryComponent = _resolveComponent("ProjectSummaryComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("myProjects")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewProject && _ctx.addNewProject(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("addNewProject")) + " ", 1),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-plus ms-2" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control search-input",
            placeholder: _ctx.$t('searchPlaceholder'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event))
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.searchQuery]
          ])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProjects, (project) => {
      return (_openBlock(), _createBlock(_component_ProjectSummaryComponent, {
        key: project.id,
        project: project,
        onProjectSelected: _ctx.openProject
      }, null, 8, ["project", "onProjectSelected"]))
    }), 128))
  ]))
}